import streamSaver from 'streamsaver';
import { downloadFileFromBlob } from 'modules/utils/downloadFileFromBlob';

const getFileNameByContentDisposition = (contentDisposition) => {
	const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/i;
	const matches = regex.exec(contentDisposition);

	let filename;

	if (matches != null && matches[2]) {
		filename = matches[2].replace(/['"]/g, '');
	}

	return decodeURI(filename);
};


const downloadFileFromReadableStream = async (response, filename, extension) => {
	const contentDisposition = response.headers.get('Content-Disposition');
	if (!filename && contentDisposition) {
		filename = getFileNameByContentDisposition(contentDisposition);
	}

	const resBlob = await response.blob();

	downloadFileFromBlob(resBlob, filename, extension);
};

export default downloadFileFromReadableStream;
